<div class="note-container" [style.height.px]="height" [style.width.px]="width">
    <div class="flex justify-between items-center mb-2">
        <div class="font-medium">
           <span>{{header}}</span>
           <span class="header-extension">{{headerExtension}}</span>
        </div>
        <span *ngIf="withOptionToClear"
            class="color-text-light text-sm font-normal hover:cursor-pointer" 
            [class.hidden]="!textarea.value" (click)="clear()">Clear
        </span>
    </div>
    <app-textarea #textarea [autofocus]="true" [optional]="true" [placeholder]="placeholder" [height]="116"
        (keydownTab)="textarea.value ? submitButton.focus(): closeButton.focus()">
    </app-textarea>
    <div class="dialog-controls-default">
        <app-button customClasses="px-4"
                    text="Cancel"
                    [minWidth]="0"
                    subStyle="transparent"
                    class="cancel-btn"
                    (clicked)="close.emit()"
                    (keydownTab)="focusTextArea()"
                    #closeButton
        ></app-button>
        <div class="flex space-x-4">
            <app-button customClasses="px-4" *ngIf="withDeleteBtn"
                [text]="'Delete'"
                [minWidth]="70"
                styleClass="settings"
                subStyle="red"
                (clicked)="delete.emit()"
                (keydownTab)="focusTextArea()"
            ></app-button>
            <app-button customClasses="px-4"
                [text]="submitBtnText"
                [minWidth]="70"
                class="save-btn"
                type="submit"
                (clicked)="submit.emit(textarea.value)"
                (keydownTab)="focusTextArea()"
                [disabled]="!textarea.value"
                #submitButton
            ></app-button>
        </div>
    </div>
</div>
